import Vue from 'vue';

import App from './App.vue';
import router from './router';
import store from './store';
import ports from './plugins/ports';
import vuetify from './plugins/vuetify';

import '@/assets/css/main.css';

Vue.use(ports, store);
Vue.config.productionTip = false;

(window as any).Vue = new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
}).$mount('#app');
